// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    MenuItem,
    Divider,
    Autocomplete,
    FormControl,
    Select as MUISelect
} from '@mui/material';
import { ManageAccounts, Cancel, ArrowBack } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import TasklistFilter from './TasklistFilter';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { borderRadius, color, height, minHeight, minWidth, padding, width } from '@mui/system';
import Select, { SingleValue } from "react-select";
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { useTranslation } from "react-i18next";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import UpdateExpiredDateModal from './UpdateExpiredDateModal';
import UpdateCommissionPercentageModal from './UpdateCommissionPercentageModal';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        //   margin: theme.spacing(2),

        //   '&.Mui-disabled': {
        //     border: 0,
        //   },
        '&:not(:first-of-type)': {
            borderRadius: theme.shape.borderRadius
        },
        '&:first-of-type': {
            borderRadius: theme.shape.borderRadius
        }
    }
}));

const StyledToggleButton = styled(ToggleButton)({
    border: 2,
    borderColor: deepPurple[500],
    backgroundColor: grey[300],
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: deepPurple[500]
    }
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1200,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px',
    height: '100%'
};

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
];

const CustomerTasklistModal = ({
    customerTasklistModalOpen,
    setCustomerTasklistModalOpen,
    activeTab,
    buttonName,
    customerRow,
    fetchCustomers,
    handleRefresh
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [view, setView] = useState('allTasks');
    const [customerID, setCustomerID] = useState(0);

    const [depositAmount, setDepositAmount] = useState(0);
    const [withdrawalAmount, setWithdrawalAmount] = useState(0);
    const [vipLevelID, setVIPLevelID] = useState(0);
    const [depositTabUpdateButtonDisabled, setDepositTabUpdateButtonDisabled] = useState(false);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChange = (event, nextView) => {
        setView(nextView);
    };

    const handleOpenModal = () => {
        setView(activeTab);
        setCustomerTasklistModalOpen(true);
    };

    useEffect(() => {
        if (customerTasklistModalOpen && customerRow?.id) {
            setCustomerID(customerRow.id);
            setView(activeTab); // or set to 'resetTasklist' by default
        }
    }, [customerTasklistModalOpen, customerRow]);

    function AllTasksTab() {
        const [taskProgress, setTaskProgress] = useState(null);
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get(`/Backend/TaskProgress/RealTime?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setTaskProgress(res.data);
                }
            } catch (error) {

            }
        };

        useEffect(() => {
            const interval = setInterval(() => {
                fetchData();
                fetchCustomerTasklist();
            }, 1000 * 2);
    
            return () => {
                clearInterval(interval);
            };
        }, []);

        const [customerTasklist, setCustomerTasklist] = useState([]);
        const fetchCustomerTasklist = async () => {
            try {
                const res = await axiosInstance.get(`/CustomerTasklist/ByCustomer/All?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    setCustomerTasklist(res.data);
                }
            } catch (error) {

            }
        };

        return (
            <Box>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='id' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.code")} : {taskProgress ? taskProgress.numberCode : ''}
                            </Box>
                        </Grid>
                        <Grid key='name' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.loginUserName")} : {taskProgress ? taskProgress.customerLoginUserName : ''}
                            </Box>
                        </Grid>
                        <Grid key='completedTasks' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.completedTaskNumber")} : {taskProgress ? taskProgress.latestCompletedTaskNumber : ''}
                            </Box>
                        </Grid>
                        <Grid key='currentTask' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.currentTask")}: {taskProgress ? taskProgress.latestTaskNumber : ''}
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='actualWalletBalance' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.actualWalletBalance")} : {taskProgress ? taskProgress.actualWalletBalance : ''}
                            </Box>
                        </Grid>
                        <Grid key='walletBalance' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.walletBalance")} : {taskProgress ? taskProgress.walletBalance : ''}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Grid item container sx={{ mt: 2 }}>
                    <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                任务类型
                            </Typography>
                        </Box>
                    </Grid>
                </Grid> */}
                <TableContainer sx={{ maxHeight: '70vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key='details' style={{ minWidth: 80 }}>{t("customer.details")}</TableCell>
                                <TableCell key='commissionPercentage' style={{ minWidth: 170 }}>{t("customer.price")}</TableCell>
                                <TableCell key='price' style={{ minWidth: 170 }}>{t("customer.profit")}</TableCell>
                                <TableCell key='estimatedNegativeAmount' style={{ minWidth: 170 }}>{t("customer.status")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customerTasklist.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell key='details' style={{fontSize: "12px"}}>
                                            {t("customer.taskNumber1")}{row.taskNumber}{t("customer.taskNumber2")}<br/>
                                            {row.taskName}<br/>
                                            {
                                                row.createdDate && 
                                                <>
                                                    {t("customer.createdAt")} 
                                                    {row.createdDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            } <br/>
                                            {
                                                row.updatedDate && 
                                                <>
                                                    {t("customer.updatedAt")}
                                                    {row.updatedDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.updatedDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                    <br/>
                                                </>
                                            }
                                            {   
                                                row.isGoldenEgg === true && 
                                                <span style={{fontSize: "12px", fontWeight: 'bolder', color: '#DAA520' }}>
                                                    {t("customer.goldenEgg")}<br/>
                                                </span> 
                                            }
                                            { 
                                                row.isCombo === true && 
                                                <span style={{fontSize: "12px", fontWeight: 'bolder', color: deepPurple[500] }}>
                                                    {t("customer.presetTask")}<br/>
                                                </span> 
                                            }
                                        </TableCell>
                                        <TableCell key='commissionPercentage' style={{fontSize: "12px"}}>
                                            {t("customer.price")} : {row.amount}<br/>
                                        </TableCell>
                                        <TableCell key='price' style={{fontSize: "12px"}}>
                                            {row.profit}
                                        </TableCell>
                                        <TableCell key='estimatedNegativeAmount' style={{fontSize: "12px", fontWeight: 'bolder', color: row.statusID === 1 ? 'orange' : row.statusID === 2 ? 'green' : ''}}>
                                            {row.statusID === 1 && (t("customer.processing"))}
                                            {row.statusID === 2 && (t("customer.completed"))}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }

    function ComboTaskSettingTab() {
        useEffect(() => {
            fetchPresetTasklist();
            fetchCustomerComboTaskIncentivePercentage();
            fetchTasklistByValueRange();
        },[]);

        const [commissionPercentage, setCommissionPercentage] = useState('');
        const [negativeAmountFrom, setNegativeAmountFrom] = useState(0);
        const [negativeAmountTo, setNegativeAmountTo] = useState(0);
        const [expiredDate, setExpiredDate] = useState(dayjs());

        const [taskAmountFrom, setTaskAmountFrom] = useState(0);
        const [taskAmountTo, setTaskAmountTo] = useState(0);
        const [filteredTasklist, setFilteredTasklist] = useState([]);
        const [filteredTasklistSelectOptions, setFilteredTasklistSelectOptions] = useState([]);
        const [selectedTasklistID, setSelectedTasklistID] = useState(0);

        const [firstGoldenEggAmount, setFirstGoldenEggAmount] = useState(0);

        const [goldenEggType, setGoldenEggType] = useState('1');

        const [viewContentName, setViewContentName] = useState("all");
        const [presetCustomerTasklistNumber, setPresetCustomerTasklistNumber] = useState(0);

        const [updateExpiredDateModalOpen, setUpdateExpiredDateModalOpen] = useState(false);
        const [updateCommissionPercentageModalOpen, setUpdateCommissionPercentageModalOpen] = useState(false);
        const [selectedCustomerRow, setSelectedCustomerRow] = useState(null);
    
        const openUpdateCommissionPercentageModal = (row) => {
            setSelectedCustomerRow(row);
            setUpdateCommissionPercentageModalOpen(true);
        };
    
        const openUpdateExpiredDateModal = (row) => {
            setSelectedCustomerRow(row);
            setUpdateExpiredDateModalOpen(true);
        };

        const submitSetCustomerTasklist = (number) => {
            setPresetCustomerTasklistNumber(number);
            setViewContentName('insert');
        };

        const submitSetGoldenEgg = (number) => {
            setPresetCustomerTasklistNumber(number);
            setViewContentName('insertGoldenEgg');
        };

        const handleBackSetCustomerTasklist = () => {
            setViewContentName("all");
            setPresetCustomerTasklistNumber(0);
        };

        const [presetTasklist, setPresetTasklist] = useState([]);
        const fetchPresetTasklist = async () => {
            try {
                const res = await axiosInstance.get(`/Customer/PresetCustomerTasklist?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setPresetTasklist(res.data);
                }
            } catch (error) {

            }
        };

        const fetchCustomerComboTaskIncentivePercentage = async () => {
            try {
                const res = await axiosInstance.get(`/Customer/Ambassador/ComboTaskIncentivePercentage?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setCommissionPercentage(res.data);
                }
            } catch (error) {

            }
        };

        const fetchTasklistByValueRange = async () => {
            try {
                const res = await axiosInstance.get(`/Tasklist/ByValueRange`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setFilteredTasklist(res.data);
                    setFilteredTasklistSelectOptions(res.data.map(result => 
                    ({
                        label: `( $ ${result.taskValue} ) ${result.name}`,
                        value: result.id
                    })));
                }
            } catch (error) {

            }
        };

        const handleTaskAmountFrom = (value) => {
            setTaskAmountFrom(value);
            if (taskAmountTo){
                setFilteredTasklistSelectOptions(filteredTasklist.filter((task) => task.taskValue >= value && task.taskValue <= taskAmountTo).map(result => 
                ({
                    label: `( $ ${result.taskValue} ) ${result.name}`,
                    value: result.id
                })));
            }
        };

        const handleTaskAmountTo = (value) => {
            setTaskAmountTo(value);
            if (taskAmountFrom){
                setFilteredTasklistSelectOptions(filteredTasklist.filter((task) => task.taskValue >= taskAmountFrom && task.taskValue <= value).map(result => 
                ({
                    label: `( $ ${result.taskValue} ) ${result.name}`,
                    value: result.id
                })));
            }
        };

        const onChangeSelectedTasklist = (selectedOption) => {
          if (selectedOption) {
            setSelectedTasklistID(selectedOption.value);
          }
        };

        const [insertCustomerTasklistButtonDisabled, setInsertCustomerTasklistButtonDisabled] = useState(false);
        const submitInsertCustomerTasklist = async () => {
            if (insertCustomerTasklistButtonDisabled) return;

            setInsertCustomerTasklistButtonDisabled(true);

            try {
                const res = await axiosInstance.post(
                    '/CustomerTasklist',
                    {
                        customerID: customerRow.id,
                        taskID: selectedTasklistID,
                        statusID: 3,
                        commissionPercentage: commissionPercentage,
                        isPreSet: true,
                        taskNumber: presetCustomerTasklistNumber,
                        negativeAmountFrom: negativeAmountFrom,
                        negativeAmountTo: negativeAmountTo,
                        expiredDate: expiredDate != null ? expiredDate.format('YYYY-MM-DD') : null
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功保存');
                    setViewContentName("all");
                    setPresetCustomerTasklistNumber(0);
                    fetchPresetTasklist();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertCustomerTasklistButtonDisabled(false);
            }
        };

        const [insertGoldenEggsButtonDisabled, setInsertGoldenEggsButtonDisabled] = useState(false);
        const submitInsertGoldenEggs = async () => {
            if (insertGoldenEggsButtonDisabled) return;
            
            setInsertGoldenEggsButtonDisabled(true);

            if (goldenEggType === '2'){
                try {
                    const res = await axiosInstance.post(
                        '/CustomerTasklist',
                        {
                            customerID: customerRow.id,
                            taskID: selectedTasklistID,
                            statusID: 3,
                            commissionPercentage: commissionPercentage,
                            isPreSet: true,
                            taskNumber: presetCustomerTasklistNumber,
                            negativeAmountFrom: negativeAmountFrom,
                            negativeAmountTo: negativeAmountTo,
                            expiredDate: expiredDate != null ? expiredDate.format('YYYY-MM-DD') : null
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                } catch (error) {
                    console.log(error);
                } finally {
                }
            }

            try {
                const res = await axiosInstance.post(
                    '/GoldenEggs',
                    {
                        customerID: customerRow.id,
                        taskNumber: presetCustomerTasklistNumber,
                        amount: goldenEggType === '1' ? firstGoldenEggAmount : 0,
                        goldenEggTypeID: goldenEggType
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功保存金蛋');
                    setViewContentName("all");
                    setPresetCustomerTasklistNumber(0);
                    fetchPresetTasklist();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertGoldenEggsButtonDisabled(false);
            }
        };

        const [taskProgress, setTaskProgress] = useState(null);
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get(`/Backend/TaskProgress/RealTime?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setTaskProgress(res.data);
                }
            } catch (error) {

            }
        };

        const [deletePresetCustomerTasklistDisabled, setDeletePresetCustomerTasklistDisabled] = useState(false);
        const submitDeletePresetCustomerTasklist = async (number) => {
            setDeletePresetCustomerTasklistDisabled(true);

            try {
                const res = await axiosInstance.post(
                    '/Preset/CustomerTasklist/ByTaskNumber',
                    {
                        customerID: customerRow.id,
                        taskNumber: number,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功取消卡单');
                    setViewContentName("all");
                    setPresetCustomerTasklistNumber(0);
                    fetchPresetTasklist();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setDeletePresetCustomerTasklistDisabled(false);
            }
        };

        const [deletePresetGoldenEggDisabled, setDeletePresetGoldenEggDisabled] = useState(false);
        const submitDeletePresetGoldenEgg = async (number) => {
            setDeletePresetGoldenEggDisabled(true);

            try {
                const res = await axiosInstance.post(
                    '/Preset/GoldenEgg/ByTaskNumber',
                    {
                        customerID: customerRow.id,
                        taskNumber: number,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功取消金蛋');
                    setViewContentName("all");
                    setPresetCustomerTasklistNumber(0);
                    fetchPresetTasklist();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setDeletePresetGoldenEggDisabled(false);
            }
        };

        const [updateExpiredDateDisabled, setUpdateExpiredDateDisabled] = useState(false);
        const submitUpdateExpiredDate = async (number) => {
            setUpdateExpiredDateDisabled(true);

            try {
                const res = await axiosInstance.put(
                    '/PresetCustomerTasklist/ExpiredDate',
                    {
                        customerID: customerRow.id,
                        taskNumber: number,
                        expiredDate: expiredDate != null ? expiredDate.format('YYYY-MM-DD') : null
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新截至日期');
                    setViewContentName("all");
                    fetchPresetTasklist();
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateExpiredDateDisabled(false);
            }
        };

        useEffect(() => {
            fetchData();
            const interval = setInterval(() => {
                fetchData();
            }, 1000 * 2);
    
            return () => {
                clearInterval(interval);
            };
        }, []);

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='id' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.code")} : {taskProgress ? taskProgress.numberCode : ''}
                            </Box>
                        </Grid>
                        <Grid key='name' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.loginUserName")} : {taskProgress ? taskProgress.customerLoginUserName : ''}
                            </Box>
                        </Grid>
                        <Grid key='completedTasks' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.completedTaskNumber")} : {taskProgress ? taskProgress.latestCompletedTaskNumber : ''}
                            </Box>
                        </Grid>
                        <Grid key='currentTask' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.currentTask")}: {taskProgress ? taskProgress.latestTaskNumber : ''}
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='actualWalletBalance' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.actualWalletBalance")} : {taskProgress ? taskProgress.actualWalletBalance : ''}
                            </Box>
                        </Grid>
                        <Grid key='walletBalance' xs={3} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.walletBalance")} : {taskProgress ? taskProgress.walletBalance : ''}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Grid item container sx={{ mt: 2 }}>
                    <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                任务类型
                            </Typography>
                        </Box>
                    </Grid>
                </Grid> */}
                {
                    viewContentName === 'all' &&
                    <>
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {t("customer.comboTaskNumber")}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <TableContainer sx={{ maxHeight: '70vh' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell key='details' style={{ minWidth: 80 }}>#</TableCell>
                                        {/* <TableCell key='quanitty' style={{ minWidth: 170 }}>数量</TableCell> */}
                                        <TableCell key='commissionPercentage' style={{ minWidth: 170 }}>{t("customer.taskCommission")}</TableCell>
                                        <TableCell key='price' style={{ minWidth: 170 }}>{t("customer.taskPrice")}</TableCell>
                                        <TableCell key='estimatedNegativeAmount' style={{ minWidth: 170 }}>{t("customer.estimatedNegativeAmount")}</TableCell>
                                        <TableCell key='goldenEgg' style={{ minWidth: 170 }}>{t("customer.goldenEgg")}</TableCell>
                                        <TableCell key='expiredDate' style={{ minWidth: 170 }}>{t("customer.expiredDate")}</TableCell>
                                        {/* <TableCell key='status' style={{ minWidth: 170 }}>可使用皮包余额</TableCell>
                                        <TableCell key='presetProducts' style={{ minWidth: 170 }}>已设置默认产品</TableCell> */}
                                        <TableCell key='setting'></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {presetTasklist.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.taskNumber}>
                                                <TableCell key='details' style={{fontSize: "12px"}}>
                                                    {t("customer.taskNumber1")}{row.taskNumber}{t("customer.taskNumber2")}
                                                </TableCell>
                                                <TableCell key='commissionPercentage' style={{ fontSize: '12px', color: !row.commissionPercentage ? 'red' : '', fontWeight: 'bolder'}}>
                                                    {
                                                        row.commissionPercentage ?
                                                        <>
                                                            <Button
                                                                style={{fontSize: "12px", padding: 'unset', minWidth: 'unset' }}
                                                                onClick={() => openUpdateCommissionPercentageModal(row)}
                                                            >
                                                                {row.commissionPercentage + '%'}
                                                            </Button>
                                                        </> 
                                                        :
                                                        t("customer.notSet")
                                                    }
                                                    {/* {row.commissionPercentage ? row.commissionPercentage + '%' : t("customer.notSet")} */}
                                                </TableCell>
                                                <TableCell key='price' style={{ fontSize: '12px', color: !row.amount ? 'red' : '', fontWeight: 'bolder'}}>
                                                    {row.amount ? row.amount : t("customer.notSet")}
                                                </TableCell>
                                                <TableCell key='estimatedNegativeAmount' style={{ fontSize: '12px', color: !row.negativeAmountFrom ? 'red' : '', fontWeight: 'bolder'}}>
                                                    {row.negativeAmountFrom ? `${row.negativeAmountFrom}` : t("customer.notSet")}
                                                </TableCell>
                                                <TableCell key='goldenEgg' style={{ fontSize: '12px', color: !row.goldenEggsAmount ? 'red' : '', fontWeight: 'bolder' }}>
                                                    {row.isGoldenEgg === true ? <>&#9989;</> : <>&#10060;</>}
                                                    {row.goldenEggsAmount ? row.goldenEggsAmount : t("customer.notSet")}
                                                </TableCell>
                                                <TableCell key='expiredDate' style={{ fontSize: '12px', color: !row.expiredDate ? 'red' : '', fontWeight: 'bolder' }}>
                                                    {
                                                        row.id && row.isPreSet === true ? 
                                                        <>
                                                            <Button
                                                                style={{fontSize: "12px", padding: 'unset' }}
                                                                onClick={() => openUpdateExpiredDateModal(row)}
                                                            >
                                                                {row.expiredDate ? <>&#9989;</> : <>&#10060;</>}
                                                                {row.expiredDate ? row.expiredDate.split('T')[0] : t("customer.notSet")}
                                                            </Button>
                                                        </> 
                                                        : t("customer.notSet")
                                                    }
                                                </TableCell>
                                                <TableCell key='setting' style={{fontSize: "12px"}}>
                                                    <Box style={{display: 'flex'}}>
                                                        {
                                                            row.isPreSet === true && (row.isGoldenEgg === false || !row.isGoldenEgg) && row.statusID == 3 ?
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        display: 'block',
                                                                        mx: 'auto',
                                                                        width: '100px',
                                                                        backgroundColor: 'red'
                                                                    }}
                                                                    onClick={() => submitDeletePresetCustomerTasklist(row.taskNumber)}
                                                                    disabled={deletePresetCustomerTasklistDisabled}
                                                                >
                                                                    {t("customer.cancelPresetTask")}
                                                                </Button>
                                                            </> :
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        display: 'block',
                                                                        mx: 'auto',
                                                                        width: '100px',
                                                                        backgroundColor: deepPurple[500]
                                                                    }}
                                                                    onClick={() => submitSetCustomerTasklist(row.taskNumber)}
                                                                    disabled={depositTabUpdateButtonDisabled}
                                                                >
                                                                    {t("customer.presetTask")}
                                                                </Button>
                                                            </>
                                                        }
                                                        {
                                                            row.isGoldenEgg === true && row.isGoldenEggOpened === false ? 
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        display: 'block',
                                                                        mx: 'auto',
                                                                        width: '100px',
                                                                        backgroundColor: 'red'
                                                                    }}
                                                                    onClick={() => submitDeletePresetGoldenEgg(row.taskNumber)}
                                                                    disabled={deletePresetGoldenEggDisabled}
                                                                >
                                                                    {t("customer.cancelGoldenEgg")}
                                                                </Button>
                                                            </>:
                                                            <>
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        display: 'block',
                                                                        mx: 'auto',
                                                                        width: '100px',
                                                                        backgroundColor: '#DAA520'
                                                                    }}
                                                                    onClick={() => submitSetGoldenEgg(row.taskNumber)}
                                                                    disabled={depositTabUpdateButtonDisabled}
                                                                >
                                                                    {t("customer.goldenEgg")}
                                                                </Button>
                                                            </>
                                                        }
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
            
                        {selectedCustomerRow && (
                            <UpdateExpiredDateModal
                                updateExpiredDateModalOpen={updateExpiredDateModalOpen}
                                setUpdateExpiredDateModalOpen={setUpdateExpiredDateModalOpen}
                                row={selectedCustomerRow}
                                fetchPresetTasklist={fetchPresetTasklist}
                            />
                        )}
            
                        {selectedCustomerRow && (
                            <UpdateCommissionPercentageModal
                                updateCommissionPercentageModalOpen={updateCommissionPercentageModalOpen}
                                setUpdateCommissionPercentageModalOpen={setUpdateCommissionPercentageModalOpen}
                                row={selectedCustomerRow}
                                fetchPresetTasklist={fetchPresetTasklist}
                            />
                        )}
                    </>
                }
                {
                    viewContentName === 'insert' &&
                    <>
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: deepPurple[500]
                                        }}
                                        onClick={handleBackSetCustomerTasklist}
                                    >
                                        <ArrowBack /> {t("customer.back")}
                                    </Button>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {t("customer.taskNumber1")}{presetCustomerTasklistNumber}{t("customer.taskNumber2")} {t("customer.comboTask")} (?)
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <TextField
                                        required
                                        name="commissionPercentage"
                                        label={t("customer.taskCommission")}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={commissionPercentage}
                                        onChange={(e) => setCommissionPercentage(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                submitInsertCustomerTasklist();
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{fontSize: '14px'}}>
                                        <DatePicker
                                            value={expiredDate}
                                            label={t("customer.expiredDate")}
                                            slotProps={{
                                                textField: {
                                                    error: false,
                                                    size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                                    sx: {
                                                    '& .MuiInputBase-root': {
                                                        fontSize: '13px',      // font size of the input
                                                        padding: '4px 8px',    // optional: reduce input padding
                                                        minHeight: '36px',     // optional: control input height
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '13px',      // font size inside input
                                                        padding: '8.5px 14px', // adjust input padding if needed
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '13px',      // label font size
                                                    },
                                                    },
                                                }
                                            }}
                                            onChange={(newValue) => setExpiredDate(newValue)}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <TextField
                                        required
                                        name="negativeAmountFrom"
                                        label={t("customer.negativeAmountFrom")}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={negativeAmountFrom}
                                        onChange={(e) => setNegativeAmountFrom(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                submitInsertCustomerTasklist();
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        <Divider />
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <TextField
                                        required
                                        name="taskAmountFrom"
                                        label={t("customer.searchTaskPriceFrom")}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={taskAmountFrom}
                                        onChange={(e) => handleTaskAmountFrom(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                submitInsertCustomerTasklist();
                                            }
                                        }}
                                    />
                                    -
                                    <TextField
                                        required
                                        name="taskAmountTo"
                                        label={t("customer.searchTaskPriceTo")}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={taskAmountTo}
                                        onChange={(e) => handleTaskAmountTo(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                submitInsertCustomerTasklist();
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                    <Select
                                        options={filteredTasklistSelectOptions}
                                        onChange={onChangeSelectedTasklist}
                                        styles={{
                                          control: (base, state) => ({
                                            ...base,
                                            backgroundColor: "#F8FAFC",
                                            borderRadius: "12px",
                                            padding: '7.5px 7px',
                                            width: '400px'
                                          })
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '40px'
                            }}
                            onClick={() => submitInsertCustomerTasklist()}
                            disabled={insertCustomerTasklistButtonDisabled}
                        >
                            {t("customer.save")}
                        </Button>
                    </>
                }
                {
                    viewContentName === 'insertGoldenEgg' &&
                    <>
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: deepPurple[500]
                                        }}
                                        onClick={handleBackSetCustomerTasklist}
                                    >
                                        <ArrowBack /> {t("customer.back")}
                                    </Button>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {t("customer.taskNumber1")}{presetCustomerTasklistNumber}{t("customer.taskNumber2")} {t("customer.comboTask")} (?)
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item container sx={{ mt: 2 }}>
                            <Grid item container md={12} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <FormControl>
                                        <MUISelect
                                            displayEmpty
                                            value={goldenEggType}
                                            onChange={(e) => setGoldenEggType(e.target.value)}
                                            styles={{
                                            control: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: "#F8FAFC",
                                                    borderRadius: "12px",
                                                    padding: '7.5px 7px',
                                                    width: '150px'
                                                })
                                            }}
                                        >
                                            <MenuItem value="1">{t("customer.bonusAmount")}</MenuItem>
                                            <MenuItem value="2">{t("customer.presetTask")}</MenuItem>
                                        </MUISelect>
                                    </FormControl>
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        <Divider />
                        {
                            goldenEggType === '1' && 
                            <>
                                <Grid item container sx={{ mt: 2 }}>
                                    <Grid item container md={12} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <TextField
                                                required
                                                name="firstGoldenEggAmount"
                                                label="金蛋数额"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={firstGoldenEggAmount}
                                                onChange={(e) => setFirstGoldenEggAmount(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        submitInsertGoldenEggs();
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        {
                            goldenEggType === '2' && 
                            <>
                                <Grid item container sx={{ mt: 2 }}>
                                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <TextField
                                                required
                                                name="commissionPercentage"
                                                label={t("customer.taskCommission")}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={commissionPercentage}
                                                onChange={(e) => setCommissionPercentage(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        submitInsertGoldenEggs();
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} style={{fontSize: '14px'}}>
                                                <DatePicker
                                                    value={expiredDate}
                                                    label={t("customer.expiredDate")}
                                                    slotProps={{
                                                        textField: {
                                                            error: false,
                                                            size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                                            sx: {
                                                            '& .MuiInputBase-root': {
                                                                fontSize: '13px',      // font size of the input
                                                                padding: '4px 8px',    // optional: reduce input padding
                                                                minHeight: '36px',     // optional: control input height
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',      // font size inside input
                                                                padding: '8.5px 14px', // adjust input padding if needed
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: '13px',      // label font size
                                                            },
                                                            },
                                                        }
                                                    }}
                                                    onChange={(newValue) => setExpiredDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container md={4} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <TextField
                                                required
                                                name="negativeAmountFrom"
                                                label={t("customer.negativeAmountFrom")}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={negativeAmountFrom}
                                                onChange={(e) => setNegativeAmountFrom(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        submitInsertGoldenEggs();
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <br/>
                                <Divider />
                                <Grid item container sx={{ mt: 2 }}>
                                    <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <TextField
                                                required
                                                name="taskAmountFrom"
                                                label={t("customer.searchTaskPriceFrom")}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={taskAmountFrom}
                                                onChange={(e) => handleTaskAmountFrom(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        submitInsertGoldenEggs();
                                                    }
                                                }}
                                            />
                                            -
                                            <TextField
                                                required
                                                name="taskAmountTo"
                                                label={t("customer.searchTaskPriceTo")}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={taskAmountTo}
                                                onChange={(e) => handleTaskAmountTo(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        submitInsertGoldenEggs();
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                            <Select
                                                options={filteredTasklistSelectOptions}
                                                onChange={onChangeSelectedTasklist}
                                                styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: "#F8FAFC",
                                                    borderRadius: "12px",
                                                    padding: '7.5px 7px',
                                                    width: '400px'
                                                })
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '40px'
                            }}
                            onClick={() => submitInsertGoldenEggs()}
                            disabled={insertGoldenEggsButtonDisabled}
                        >
                            {t("customer.save")}
                        </Button>
                    </>
                }
            </Box>
        );
    }

    function ComboTaskHistoryTab() {
        const [presetCustomerTasklist, setPresetCustomerTasklist] = useState([]);
        const [refreshButtonDisabled, setRefreshButtonDisabled] = useState(false);

        const fetchData = async () => {
            try {
                const res = await axiosInstance.get(`/Customer/PresetCustomerTasklist/All?customerID=${customerRow.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (res.status === 200) {
                    setPresetCustomerTasklist(res.data);
                }
            } catch (error) {

            }
        };

        useEffect(() => {
            fetchData();
        }, []);

        return (
            <Box>
                <Box style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                    <Button
                        variant="contained"
                        sx={{
                            width: '100px',
                            backgroundColor: deepPurple[500]
                        }}
                        onClick={() => fetchData()}
                        disabled={refreshButtonDisabled}
                    >
                        {t("customer.refresh")}
                    </Button>
                </Box>
                <TableContainer sx={{ maxHeight: '70vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key='details' style={{ minWidth: 80 }}>{t("customer.details")}</TableCell>
                                <TableCell key='commissionPercentage' style={{ minWidth: 170 }}>{t("customer.price")}</TableCell>
                                <TableCell key='price' style={{ minWidth: 170 }}>{t("customer.profit")}</TableCell>
                                <TableCell key='estimatedNegativeAmount' style={{ minWidth: 170 }}>{t("customer.status")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {presetCustomerTasklist.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell key='details' style={{fontSize: "12px"}}>
                                            {t("customer.taskNumber1")}{row.taskNumber}{t("customer.taskNumber2")}<br/>
                                            {row.taskName}<br/>
                                            {
                                                row.createdDate && 
                                                <>
                                                    {t("customer.createdAt")} 
                                                    {row.createdDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            } <br/>
                                            {
                                                row.updatedDate && 
                                                <>
                                                    {t("customer.updatedAt")}
                                                    {row.updatedDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.updatedDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            }
                                            
                                        </TableCell>
                                        <TableCell key='commissionPercentage' style={{fontSize: "12px"}}>
                                            {t("customer.price")} : {row.amount}<br/>
                                        </TableCell>
                                        <TableCell key='price' style={{fontSize: "12px"}}>
                                            {t("customer.taskCommission")} : {row.commissionPercentage}<br/>
                                            {t("customer.profit")} : {row.profit}
                                        </TableCell>
                                        <TableCell key='estimatedNegativeAmount' style={{fontSize: "12px", fontWeight: 'bolder', color: row.statusID === 1 ? 'orange' : row.statusID === 2 ? 'green' : ''}}>
                                            {row.statusID === 1 && (t("customer.processing"))}
                                            {row.statusID === 2 && (t("customer.completed"))}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }

    return (
        <>
            {/* <Button
                onClick={handleOpenModal}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    width: 'fit-content',
                    height: 'fit-content',
                    color: 'white',
                    '&.Mui-selected, &.Mui-selected:hover': {
                        color: deepPurple[500],
                        backgroundColor: 'white'
                    },
                    fontSize: '12px'
                }}
            >
                {buttonName}
            </Button> */}
            <Modal
                open={customerTasklistModalOpen}
                onClose={() => setCustomerTasklistModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("customer.customerTasklistDetails")}
                        </Typography>
                        <Cancel onClick={() => setCustomerTasklistModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Box
                        id="modal-modal-description"
                        sx={{
                            overflowY: 'auto'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%' 
                            }}
                        >
                            <StyledToggleButtonGroup
                                value={view}
                                exclusive
                                onChange={handleChange}
                                sx={{
                                    flexDirection: { xs: 'column', md: 'row' }
                                }}
                            >
                                <StyledToggleButton value="allTasks" aria-label="deposit">
                                    {t("customer.allTask")}
                                </StyledToggleButton>
                                <StyledToggleButton value="comboTaskSetting" aria-label="comboTaskSetting">
                                    {t("customer.comboTaskSetting")}
                                </StyledToggleButton>
                                <StyledToggleButton value="comboTaskHistory" aria-label="comboTaskHistory">
                                    {t("customer.comboTaskHistory")}
                                </StyledToggleButton>
                            </StyledToggleButtonGroup>
                        </Box>
            
                        {view === 'allTasks' && (
                            <>
                                <AllTasksTab />
                            </>
                        )}
                        {view === 'comboTaskSetting' && (
                            <>
                                <ComboTaskSettingTab />
                            </>
                        )}
                        {view === 'comboTaskHistory' && (
                            <>
                                <ComboTaskHistoryTab />
                            </>
                        )}
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default CustomerTasklistModal;